<template>
    <ion-page >
        <ion-content style="height: 100vh; overflow-y: auto; text-align:center; padding-top:10vh; top:7.7vh">
            <!-- Adjust padding-top to ensure content is not blocked by the header -->
            <ion-item style="text-align:center" lines="none">
                <ion-label class="blue" style="font-size: xx-large;">
                    <b>From start to finish, experience you can count on</b>
                </ion-label>
            </ion-item>
            <ion-grid>
                <ion-row style="gap: 31px;">
                    <ion-col v-for="(project, index) in projects" :key="index" style="    justify-items: center;">
                        
                        <ion-img class="project-img"
                            :src="project.image_location[0].asset.startsWith('$') ? project.image_location[0].asset.replace('$', '') : 'https://portfolio-assets-7zc.pages.dev/projects/' + project.image_location[0].asset"></ion-img>
                        <div style="margin-top: 10px;">
                            {{ project.description }}
                        </div>
                        <router-link v-if="project.image_location.length >1" class="blue" style="margin-top: 10px; color:white; " 
                            :to="{ path: '/project', query: { assets: JSON.stringify(project.image_location), routeTitle: project.description }}">
                                <ion-button style="font-family:  'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">View Collage</ion-button>
                            </router-link>
                        
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>
<style>
.project-img::part(image) {
    border-radius: 10px;
    min-width: 270px;
    min-height: 267px;
    width: 270px;
    height: 267px;
    /*margin-left:30%;*/
}

.blue {
    color: #1C8AF7 !important;
}

.center-container {
    display: flex;
    justify-content: center;
    /* Horizontally center */
}

.inner-text {
    text-align: left;
    /* Lines start at same point */
}
</style>
<script setup lang="ts">
import { getProject, getProjects } from "../ProjectHelper";

import { computed, ref } from "vue";
import {
    IonPage,
    IonIcon,
    IonImg,
    IonHeader,
    IonGrid,
    IonFooter,
    IonLabel,
    IonToolbar,
    IonButtons,
    IonSelectOption,
    IonMenuButton,
    IonButton,
    IonContent,
    IonList,
    IonItem,
    IonTitle,
    IonRow,
    IonCol,
    IonInput,
    IonToast,
    IonSelect,
    IonRadioGroup,
    IonRadio,
} from "@ionic/vue";
/**
 * @file ProjectPage.vue
 * @description This file defines the ProjectPage component, which displays a grid of projects with images and descriptions.
 */
var projects = getProjects()

</script>
<script lang="ts">
import * as outlines from 'ionicons/icons';

</script>